import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-throughput-order-place',
  templateUrl: './throughput-order-place.component.html',
  styleUrls: ['./throughput-order-place.component.css'],
})
export class ThroughputOrderPlaceComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  message: string = '';
  @Output() errorEmitter = new EventEmitter();

  constructor(private api: ApiService) {}
  total: number = 0;
  dataSourceThroughput: any = {
    chart: {
      theme: 'fusion',
      maxBarHeight: '14',
      showValues: '1',
      showSum: '2',
      baseFontSize: '13',
      plottooltext: '<b>$dataValue</b> movimentos do tipo <b>$seriesName</b>',
      drawcrossline: '1',
    },
    categories: [
      {
        category: [],
      },
    ],
    dataSet: [],
  };
  loading: boolean = true;
  errorApi: boolean = false;
  typeClassificationLocation: string = '';
  dataLabel: string = '';
  inValue: boolean = false;

  ngOnInit(): void {
    this.typeClassificationLocation = '';
  }

  filterItem(item: any) {
    this.total = 0;
    this.errorApi = false;
    this.loading = true;
    this.getOrderThroughputPlaceInformation(item);
  }

  async getOrderThroughputPlaceInformation(item: any) {
    this.inValue = false;
    this.typeClassificationLocation = item.typeClassificationLocationDescription
      ? '- ' + item.typeClassificationLocationDescription
      : '';
    this.dataLabel = '';
    if (!this.validateFilter(item)) return;

    try {
      this.total = 0;
      const dataMin = new Date(item.dataMin);
      dataMin.setDate(dataMin.getDate() + 1);
      const dataMax = new Date(item.dataMax);
      dataMax.setDate(dataMax.getDate() + 1);
      this.dataLabel = `${dataMin.toLocaleDateString()} a ${dataMax.toLocaleDateString()}`;
      this.dataSourceThroughput.dataSet = [];
      this.dataSourceThroughput.categories[0].category = [];
      const itemProductAux =
        item.typeProduct != '' ? item.typeProduct : [0, 1, 2, 3];

      const result = await this.api
        .getOrderThroughputPlaceInformation(
          item.dataMin,
          item.dataMax,
          item.typeClassificationLocation,
          itemProductAux,
          item.branch
        )
        .toPromise();
      if (result.items.length != 0) {
        const labels = result.items.map(
          (x: any) => x.classificationDescription
        );
        result.items.forEach(
          (a: any) =>
            (this.total +=
              +a.normalMovementQuantity + +a.transferMovementQuantity)
        );

        for (const itemFor of labels) {
          this.dataSourceThroughput.categories[0].category.push({
            label: itemFor,
          });
        }

        const qtNormal = result.items.map((x: any) => x.normalMovementQuantity);
        const qtTransfer = result.items.map(
          (x: any) => x.transferMovementQuantity
        );

        const listAux = [
          { label: 'Normal', value: qtNormal },
          { label: 'Repasse', value: qtTransfer },
        ];

        for (const auxItem of listAux) {
          this.dataSourceThroughput.dataSet.push({
            seriesName: auxItem.label,
            data: this.getValueOf(auxItem.value),
          });
        }
        this.errorApi = false;
      } else {
        this.message = CONSTANTS.MESSAGES.DATA_NULL_THROUGHPUTPLACE;
        this.errorApi = true;
      }
    } catch (error) {
      this.loading = false;
      this.errorApi = true;
      this.formatErrorMensagem(error.error[0].message);
    } finally {
      if (!this.inValue) {
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_NULL_THROUGHPUTPLACE;
        this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_THROUGHPUTPLACE);
      }
      this.loading = false;
    }
  }

  getValueOf(objValue: any): any {
    let aux = [];
    for (let i of objValue) {
      if (i > 0) {
        this.inValue = true;
        aux.push({
          value: i,
        });
      } else {
        aux.push({
          value: i,
          showValue: '0',
        });
      }
    }
    return aux;
  }

  validateFilter(item: any): boolean {
    if (item.typeClassificationLocation.length === 0) {
      this.message = CONSTANTS.MESSAGES.DATA_CLASSLOCATION_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if (item.branch == '') {
      this.message = CONSTANTS.MESSAGES.DATA_BRANCH_NULL;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    if(item.dateInvalid)
    {
      this.message = CONSTANTS.MESSAGES.DATA_MIN_INVALID;
      this.loading = false;
      this.errorApi = true;
      return false;
    }
    return true;
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: Throughput-Order \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
